import { useState, useCallback } from 'react';
import { QnANotification } from '../types';

export interface UseNotificationsReturn {
  notification: QnANotification | null;
  showNotification: (
    message: string,
    type?: 'success' | 'info' | 'warning',
    autoHide?: boolean,
    timeout?: number
  ) => void;
  dismissNotification: () => void;
}

export function useNotifications(): UseNotificationsReturn {
  const [notification, setNotification] = useState<QnANotification | null>(null);

  const showNotification = useCallback((
    message: string,
    type: 'success' | 'info' | 'warning' = 'info',
    autoHide = true,
    timeout = 3000,
  ) => {
    const newNotification: QnANotification = {
      id: `notification-${Date.now()}`,
      type,
      message,
      timestamp: new Date(),
      autoHide,
      timeout,
    };
    setNotification(newNotification);
  }, []);

  const dismissNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return {
    notification,
    showNotification,
    dismissNotification,
  };
}
